exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".input-area[data-v-d5773c94]{margin:10px}.star-container[data-v-d5773c94]{font-size:0}.star-container .md-icon[data-v-d5773c94]{cursor:pointer;color:gold!important}.rating-container[data-v-d5773c94]{display:flex;flex-direction:column}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-d5773c94","scoped":true,"sourceMap":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./Components/supportNew/ratingControl.vue
// module id = 413
// module chunks = 0